import api from "@/lib/api";

export default {
  getById(id) {
    return api.get("/api/v1/adm/company/get-by-id", { params: { id } });
  },
};
